export interface ErrorParamsType {
    errorStatus?: number;
    errorMessage: string;
}

export interface ErrorResponseType {
    status: number;
    message: string;
}

const constructErrorResponse = (params: ErrorParamsType): ErrorResponseType => {
    return {
        status: params.errorStatus || 500,
        message: params.errorMessage || 'Unknown error occurred',
    };
};

export default constructErrorResponse;
